import type {DocumentManager} from '@wix/document-manager-core'
import type {Experiment} from '@wix/document-services-types'
import type {AppsInstallStateExtAPI} from '../../../appsInstallState'
import type {MasterPageMigrator} from '../dataMigrationRunner'

const version = 4

const migrateMasterPage = (documentManager: DocumentManager, experimentInstance: Experiment) => {
    const {extensionAPI, dal, logger} = documentManager

    if (!experimentInstance.isOpen('dm_fragmentsApps')) {
        return
    }

    logger.interactionStarted('migrateAppsStateToFragmentMigrator', {
        extras: {
            version
        }
    })

    const {appsInstallState} = extensionAPI as AppsInstallStateExtAPI
    appsInstallState.migrateAppsStateToFragment()
    const oldState = dal.get(appsInstallState.getStateMapPointerFromMasterPage())

    logger.interactionEnded('migrateAppsStateToFragmentMigrator', {
        extras: {
            oldState,
            version
        }
    })
}

const experimentalVersions = [{experiment: 'dm_fragmentsApps', version: 5}]

const name = 'migrateAppsStateToFragment'

export const migrateAppsStateToFragment: MasterPageMigrator = {
    migrateMasterPage,
    name,
    version,
    experimentalVersions
}
